/**
 * What's selected / hovered on the map.
 *
 * Stage 3 uses this only to draw the selection ring and the hover cursor; the
 * detail panel that reads the same selection is built in stage 6. Kept as its
 * own store so that panel can subscribe without the map re-rendering.
 */
import { create } from "zustand";

interface SelectionState {
  selectedEpisodeId: string | null;
  selectedSourceId: string | null;
  hoveredEpisodeId: string | null;
  selectEpisode: (episodeId: string | null) => void;
  selectSource: (sourceId: string | null) => void;
  setHovered: (episodeId: string | null) => void;
  clear: () => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  selectedEpisodeId: null,
  selectedSourceId: null,
  hoveredEpisodeId: null,
  selectEpisode: (episodeId) => set({ selectedEpisodeId: episodeId, selectedSourceId: null }),
  selectSource: (sourceId) => set({ selectedSourceId: sourceId, selectedEpisodeId: null }),
  setHovered: (episodeId) => set({ hoveredEpisodeId: episodeId }),
  clear: () => set({ selectedEpisodeId: null, selectedSourceId: null }),
}));
